import { Controller } from "@hotwired/stimulus";

// Connects to data-controller='categories--admin--review-gifts--constituent-id-radio'
//
// Clears the constituent ID text input whenever the user selects a radio option
// that hides that field (e.g. "Create a new constituent in Raiser's Edge NXT").
// This prevents a previously-typed value from being silently submitted after the
// user switches away from the "Enter known Constituent ID" option.
export default class extends Controller {
  static targets = ["constituentIdInput"];

  clearConstituentId() {
    if (this.hasConstituentIdInputTarget) {
      this.constituentIdInputTarget.value = "";
    }
  }
}
